import dayjs from 'dayjs';
import { Activity } from 'src/types';

export const sortPinnedActivities = (activities: Activity[]): Activity[] => {
  return activities.sort((a, b) => {
    if ('pinnedAt' in a && a.pinnedAt && 'pinnedAt' in b && b.pinnedAt) {
      return dayjs(a.pinnedAt).diff(b.pinnedAt);
    } else if ('pinnedAt' in a && a.pinnedAt) {
      return -1;
    } else if ('pinnedAt' in b && b.pinnedAt) {
      return 1;
    } else {
      return dayjs(getTimeStamp(b)).diff(getTimeStamp(a));
    }
  });
};

export const getTimeStamp = (activity: Activity) => {
  switch (activity.activityType) {
    case 'textThread':
      return activity.lastMessageTimestamp;
    case 'note':
      return activity.updatedAt;
    case 'task':
      return activity.completedAt || activity.dueAt;
    case 'versionInfo':
    case 'call':
      return activity.createdAt;
  }

  return null;
};
